<template>
  <div>
    <div class="back" @click="back">
      <i></i>
      <span>返回</span>
    </div>
    <el-card>
      <!-- 按钮 -->
      <!-- <div class="operation_btn">
        <div class="operation_left">
          <el-button> <i class="iconfont icon-jiami"></i>加密 </el-button>
          <el-button>
            <i class="iconfont icon-jiemi_huaban"></i>解密
          </el-button>
        </div> -->
      <!-- <div class="operation_right">
          <el-button> <i class="iconfont icon-sousuo"></i>搜索 </el-button>
          <el-button> <i class="iconfont icon-zhongzhi-"></i>重置 </el-button>
        </div> -->
      <!-- </div> -->
      <div class="attention">
        <p>
          注: 只能对自己添加的试卷进行加密。若需要修改独立密码/撤销独立密码，请前往"个人中心"
          => "独立密码"进行操作。
        </p>
      </div>
      <!-- 表格 -->
      <div class="hos_table">
        <el-table
          :data="getData"
          style="width: 100%"
          :cell-class-name="stateColor"
          :row-class-name="tableRowClassName"
          :header-cell-style="{
            'background-color': '#8FCBFF',
            color: '#333333',
            height: '60px',
          }"
        >
          <!-- <el-table-column type="selection" width="80"></el-table-column> -->
          <el-table-column label="序号" width="80">
            <template slot-scope="scope">
              {{ scope.$index + (pageIndex - 1) * eachPageNum + 1 }}
            </template>
          </el-table-column>
          <el-table-column
            v-for="(item, index) in formColumns"
            :key="index"
            :prop="item.prop"
            :label="item.label"
            :width="item.width"
            height="150"
            label-height="50"
            align="center"
          >
          </el-table-column>
          <el-table-column prop="address" label="操作" align="center">
            <template slot-scope="scope">
              <div>
                <el-button
                  type="text"
                  size="small"
                  style="font-size: 16px"
                  v-if="scope.row.IsCrypto == '已加密'"
                  @click="examcrypto(scope.row)"
                  >解密</el-button
                >
                <el-button
                  type="text"
                  size="small"
                  style="font-size: 16px"
                  v-else-if="scope.row.IsCrypto == '未加密'"
                  @click="examcrypto(scope.row)"
                  >加密</el-button
                >
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!-- 分页 -->
      <div class="foot_box">
        <div class="foot_pagetions">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page.sync="pageIndex"
            :page-size="eachPageNum"
            :page-sizes="pagesizesarr"
            layout="prev, pager, next,sizes, jumper"
            :total="total"
            class="pagination"
          >
          </el-pagination>
        </div>
      </div>
    </el-card>
  </div>
</template>

<script>
import { checkAge } from "@/utils/validata";
import loginvuex from "@/store/index";
import { cryptoexamlist, cryptoExam } from "@/api/examination.js";
import md5 from "js-md5";
export default {
  data() {
    return {
      pageIndex: 1,
      eachPageNum: 10,
      pagesizesarr: [5, 10, 20, 50, 100],
      total: 100,
      getData: [],
      pass: "",
      formColumns: [
        {
          prop: "ExamName",
          label: "试卷名称",
          width: "320px",
        },
        {
          prop: "IsCrypto",
          label: "加密状态",
          width: "220px",
        },
        {
          prop: "IsCryptoEndTimes",
          label: "最后加密时间",
          width: "380px",
        },
        {
          prop: "IsCryptoStartTimes",
          label: "最后解密时间",
          width: "100px",
          width: "380px",
        },
      ],
      // 规则控制 - 规则字段一定要和数据的字段保持一致
      rules: {
        account: [{ validator: checkAge, trigger: "blur" }],
      },
    };
  },
  props: ["cutcoms"],
  methods: {
    back() {
      // this.$parent.cutcoms(0);
      this.$destroy();
      this.$router.push("/papers");
    },
    stateColor({ row, column, rowIndex, columnIndex }) {
      //   console.log('object', row, column, rowIndex, columnIndex)
      if (row.IsCrypto === "已加密" && columnIndex === 2) {
        return "red";
      } else if (row.IsCrypto === "未加密" && columnIndex === 2) {
        return "gray";
      }
    },
    // 时间转换的处理
    BeginTime() {
      this.getData.map((item) => {
        if (item.IsCryptoEndTime != null || item.IsCryptoStartTimes != null) {
          item.IsCryptoEndTimes = this.$moment(item.IsCryptoEndTime).format(
            "YYYY/MM/DD HH:mm"
          );
          item.IsCryptoStartTimes = this.$moment(item.IsCryptoStartTime).format(
            "YYYY/MM/DD HH:mm"
          );
        } else {
          item.IsCryptoEndTimes = "暂无";
          item.IsCryptoStartTimes = "暂无";
        }
      });
    },
    // 表格背景颜色
    tableRowClassName({ row, rowIndex }) {
      if (rowIndex % 2 === 1) {
        return "success-row";
      } else if (rowIndex % 2 === 0) {
        return "warning-row";
      }
      return "";
    },
    // 加密状态
    ChannelMerger() {
      this.getData = this.getData.map((item) => {
        if (item.IsCrypto === 0) {
          item.IsCrypto = "未加密";
        } else if (item.IsCrypto === 1) {
          item.IsCrypto = "已加密";
        }
        return item;
      });
    },
    // 分页
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.eachPageNum = val;
      this.examGetData(); // 重新发起请求
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.pageIndex = val;
      this.examGetData();
    },
    handleSelectionChange(val) {
      this.multipleSelection = val; // 批量删除多选状态
    },
    submitForm(ruleForm) {
      this.$refs[ruleForm].validate((valid) => {
        if (valid) {
          alert("submit!");
        } else {
          console.log("error submit!");
          return false;
        }
      });
    },
    // 数据请求
    async examGetData() {
      let res = {
        pageIndex: this.pageIndex - 1,
        eachPageNum: this.eachPageNum,
        examType: 0, // 0代表在线考试
        guid: JSON.parse(loginvuex.state.userlist).guid,
        userID: JSON.parse(loginvuex.state.userlist).userID,
      };
      const Data = await cryptoexamlist(res);
      if (Data.data.Status === 200) {
        this.getData = Data.data.Data.data;
        this.total = Data.data.Data.count;
        this.ChannelMerger();
        this.BeginTime(); // 时间转换
        console.log(Data.data.Data.count, "撒娇的哈斯不会的不会");
      } else {
        this.$message.error("数据获取不到");
      }
    },
    // 试卷加密
    async examcrypto(row) {
      this.pass = sessionStorage.getItem("encryptpaw");
      let params = {
        examID: row.ExamID,
        guid: JSON.parse(loginvuex.state.userlist).guid,
        userID: JSON.parse(loginvuex.state.userlist).userID,
        cryptoPwd: md5(this.pass), //独立密码
      };
      const Data = await cryptoExam(params);
      // console.log(Data.data.Status, "请求状态码");
      if (Data.data.Status === 200) {
        if (row.IsCrypto == "未加密") {
          this.$message({
            message: "已加密操作成功",
            type: "success",
          });
        } else if (row.IsCrypto == "已加密") {
          this.$message({
            message: "已解密操作成功",
            type: "success",
          });
        }
      } else {
        this.$message.error("数据获取不到");
      }
      this.examGetData(); //重新发起请求
    },
  },
  created() {
    this.examGetData(); //列表的数据请求
  },
};
</script>

<style lang="scss" scoped>
.back {
  border-bottom: 1px solid #f8f8f8;
  padding: 10px 0px 9px 24px;
  background-color: #fff;
  margin-bottom: 24px;
  border-radius: 0 0 10px 10px;
  i {
    display: inline-block;
    width: 12px;
    height: 12px;
    //  background-color: aqua;
    border-top: 2px solid #999999;
    border-left: 2px solid #999999;
    transform: scaleY(0.6) rotate(-45deg);
  }
  span {
    cursor: pointer;
    width: 47px;
    height: 25px;
    font-size: 18px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #999999;
  }
}
.operation_btn {
  display: flex;
  justify-content: space-between;
  .el-button {
    width: 88px;
    height: 40px;
    color: #ffffff;
    span > i {
      font-size: 14px !important;
      margin-right: 5px;
    }
  }
  .operation_left {
    .el-button:nth-child(1) {
      background: #ee6717;
    }
    .el-button:nth-child(2) {
      background: #00d254;
      margin-left: 24px;
    }
  }
  .operation_right {
    .el-button:nth-child(1) {
      background: #1890ff;
      color: #ffffff;
    }
    .el-button:nth-child(2) {
      background: #ffffff;
      color: #999999;
      margin-left: 24px;
    }
  }
}
::v-deep .el-table .green .cell {
  color: #00d254 !important;
}
::v-deep .el-table .red .cell {
  color: #ff0000 !important;
}

::v-deep .el-table .warning-row {
  background: #fff !important;
}

::v-deep .el-table .success-row {
  background: #f8fcff !important;
}
// 分页
.foot_box {
  position: relative;
  height: 88px;
}
.foot_pagetions {
  display: flex;
  position: absolute;
  right: 16px;
  bottom: 30px;
  p {
    //background-color: #333333;
    text-align: center;
    line-height: 32px;
    font-family: 微软雅黑;
    color: #949494;
  }
  span {
    line-height: 32px;
    font-size: 15px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #333333;
    b {
      color: #ff0000;
    }
  }
}
.pagination {
  ::v-deep .el-pager {
    li {
      border: 1px solid #d9d9d9;
      margin-right: 8px;
      &.active {
        color: #ffffff;
        background-color: #409eff;
        border: none;
      }
    }
  }
  // ::v-deep .el-pagination__jump {
  //   // &::before {
  //   //   content: "10条/页";
  //   //   width: 82px;
  //   //   border: 1px solid #d9d9d9;
  //   //   height: 28px;
  //   //   border-radius: 2px;
  //   //   text-align: center;
  //   //   display: inline-block;
  //   //   margin-right: 8px;
  //   //   cursor: pointer;
  //   // }
  // }
}
.hos_table {
  margin-top: 25px;
}
::v-deep .el-table th > .cell {
  text-align: center;
}
::v-deep .cell {
  text-align: center;
}
::v-deep .el-table .gray .cell {
  color: #aaaaaa !important;
}
.attention{
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 18px;
  font-weight: bold;
  color: #767676;
}
</style>